import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { isSxArray } from 'src/shared/utils/isSxArray';
import { useCompareContext } from '../../../Context';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../../ColumnContext';
type RemoveCardButtonContainerProps = {
  additionalProps?: BoxProps;
};
export function RemoveCardButtonContainer(t0) {
  const $ = _c(21);
  const {
    additionalProps,
    children
  } = t0;
  const {
    showStickyHeader
  } = useCompareContext();
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] !== additionalProps) {
    t1 = additionalProps ?? {};
    $[0] = additionalProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sx
  } = t1;
  let t2;
  if ($[2] !== sx) {
    t2 = sx && isSxArray(sx) ? sx : sx ? [sx] : [];
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const extendedSx = t2;
  const t3 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      md: "flex",
      xs: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = showStickyHeader ? 0 : 2;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      xs: t5,
      md: 3
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = showStickyHeader ? 2 : 0;
  let t8;
  if ($[8] !== t7) {
    t8 = {
      xs: t7,
      md: 0
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t6 || $[12] !== t8) {
    t9 = {
      display: t4,
      justifyContent: "center",
      mb: t6,
      mt: t8,
      height: "1.5rem"
    };
    $[10] = t4;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== extendedSx || $[15] !== t9) {
    t10 = [t9, ...extendedSx];
    $[14] = extendedSx;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== additionalProps || $[18] !== children || $[19] !== t10) {
    t11 = <Box {...additionalProps} sx={t10}>{children}</Box>;
    $[17] = additionalProps;
    $[18] = children;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}